import { InputLabel as InputLabelMui } from "@mui/material";

const InputLabel = ({
  id,
  className,
  children,
  classes,
  color,
  disableAnimation,
  disabled,
  error,
  focused,
  margin,
  required,
  shrink,
  size,
  sx,
  variant,
  htmlFor,
}) => {
  return (
    <InputLabelMui
      id={id}
      className={className}
      classes={classes}
      color={color}
      htmlFor={htmlFor}
      disableAnimation={disableAnimation ? true : false}
      disabled={disabled ? true : false}
      error={error ? true : false}
      focused={focused ? true : false}
      margin={margin}
      required={required}
      shrink={shrink ? true : false}
      size={size}
      sx={sx}
      variant={variant}
    >
      {children}
    </InputLabelMui>
  );
};

export default InputLabel;
